
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { ROUTE_NAME_COLLECTION } from '@/modules/collection/router';
import { useCollectionItemList } from '@/modules/collection/item/model/list';
import { CollectionSelectOptions } from '@/modules/collection/types';
import { renderOption } from '@/common/utils/helpers';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: 'CollectionItemList',
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, fetchList, collectionInfo, actions } = useCollectionItemList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Id', key: 'id' },
                { type: TableColumnType.Text, label: 'AssetId', key: 'assetId' },
                { type: TableColumnType.Text, label: 'SortOrder', key: 'sortOrder' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: {
                            name: ROUTE_NAME_COLLECTION.ITEM.EDIT(collectionInfo.type),
                            params: { collectionId: row.collectionId, collectionItemId: row.id }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return {
            table,
            list,
            total,
            fetchList,
            collectionInfo,
            CollectionSelectOptions,
            renderOption,
            ROUTE_NAME_COLLECTION
        };
    }
});
